import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {merge, Observable, OperatorFunction, Subject} from "rxjs";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {APIHelper} from "../../../apihelper";
import {SharedResources} from "../../../shared-resources";
import {debounceTime, distinctUntilChanged, filter, map} from "rxjs/operators";
import {Orders} from "../../../models/orders";

@Component({
  selector: 'app-edit-order',
  templateUrl: './edit-order.component.html',
  styleUrls: ['./edit-order.component.css']
})
export class EditOrderComponent implements OnInit {


  @ViewChild('instance', {static: true}) instance: any;
  order = new Orders();
  focus$ = new Subject<string>();
  click$ = new Subject<string>();
  incoterms: string[] = [];
  partnumbers: string[] = [];
  currentPartNumber: string = '';
  currentQuantity: number = 0;
  currentModifiablePartNo: string = ''
  lines: Map<string, number> = new Map<string, number>();
  linesCountries: Map<string, string> = new Map<string, string>();
  linesDetails: Map<string, any> = new Map<string, any>();
  currentSN: string = '';
  currentOrderPageSN: any;
  numberOfOrderPagesSN: any;
  currentMAC: string = '';
  numberOfOrderPagesMAC: any;
  currentOrderPageMAC: any;
  currentModifiableQuantity: any;
  currentCountryOfExpedition: any = "";
  currentModifiableCountryOfExpedition: any;
  countries: any = [];
  parts: any = [];
  currentPart: string = '';
  backupLineDetail: any = {
    "details": {}
  };

  ordersForm = new FormGroup(
    {
      Id: new FormControl(''),
      PO: new FormControl('',
        [
          Validators.required,
          Validators.pattern('^PO[0-9]+$')
        ]),
      NumarFactura: new FormControl('',
        [
          Validators.required
        ]),
      DataReceptie: new FormControl('',
        [
          Validators.required
        ]),
      ConditieLivrare: new FormControl('',
        [
          Validators.required
        ]),
      Stare: new FormControl('')
    }
  )
  currentModifiablePartName: string = '';


  constructor(private http: HttpClient, private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.order = SharedResources.currentEditOrder;
    this.ordersForm.controls.Id.setValue(this.order.Id);
    this.ordersForm.controls.PO.setValue(this.order.PO);
    this.ordersForm.controls.NumarFactura.setValue(this.order.NumarFactura);
    this.ordersForm.controls.DataReceptie.setValue(this.order.DataReceptie);
    this.ordersForm.controls.ConditieLivrare.setValue(this.order.ConditieLivrare);
    this.ordersForm.controls.Stare.setValue(this.order.Stare);
    this.http.get<any>(`${APIHelper.APIUrl}country`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.countries = response.map((t: any) => t.Nume + ' (' + t.Cod + ')').sort((t1: any, t2: any) => {
          return t1.localeCompare(t2);
        });
      }, (error: any) => {
        alert("Eroare la încărcarea țărilor!");
        SharedResources._isLoadingBS.next(false);
      });
    this.http.get<any>(`${APIHelper.APIUrl}orderdetail?OrderId=${this.order.Id}`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        console.log(response)
        for (let olc of response.OrderLineCodes) {
          this.lines.set(olc.PartNo.toUpperCase() + '\t' + olc.PartName.toUpperCase(), olc.Cantitate);
          this.linesCountries.set(olc.PartNo.toUpperCase() + '\t' + olc.PartName.toUpperCase(), olc.TaraExpediere);
          this.linesDetails.set(olc.PartNo.toUpperCase() + '\t' + olc.PartName.toUpperCase(), {
            "sn": olc.SN,
            "mac": olc.MAC
          });

        }
      }, (error: HttpErrorResponse) => {
        alert("Eroare la încărcarea comenzii!");
        SharedResources._isLoadingBS.next(false);
      });
    this.http.get<any>(`${APIHelper.APIUrl}partnumber`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.partnumbers = response.map((pn: string) => pn.toUpperCase()).sort((pn1: any, pn2: any) => {
          return pn1.localeCompare(pn2);
        });
      }, (error: any) => {
        alert("Eroare la încărcarea listei de produse!");
        SharedResources._isLoadingBS.next(false);
      });


    this.http.get<any>(`${APIHelper.APIUrl}incoterm`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.incoterms = response.map((i: any) => i.Nume).sort((i1: any, i2: any) => {
          return i1.localeCompare(i2);
        });
      }, (error: any) => {
        alert("Eroare la încărcarea condițiilor de livrare!");
        SharedResources._isLoadingBS.next(false);
      });

  }

  cancelAddOrder() {
    SharedResources.currentScreen = 'orders';
    SharedResources._currentScreenBS.next(SharedResources.currentScreen);
  }

  saveOrder(editOrderForm: any) {
    SharedResources._isLoadingBS.next(true);

    this.http.put<any>(`${APIHelper.APIUrl}order`,
      editOrderForm.value,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.http.put<any>(`${APIHelper.APIUrl}orderdetail`,
          {
            OrderId: response.Id,
            OrderLineCodes: this.getOrderLineCodes()
          },
          {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem('token')}`
            })
          }).subscribe((response: any) => {
          alert("Comandă salvată cu succes!");
          SharedResources._isLoadingBS.next(false);
          SharedResources._currentScreenBS.next('orders');
        }, (error: any) => {
          alert(error.error);
          SharedResources._isLoadingBS.next(false);
        });
      }, (error: any) => {
        alert(error.error);
        SharedResources._isLoadingBS.next(false);
      });
  }

  search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;
    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => (term === '' ? this.partnumbers
        : this.partnumbers.filter((v: any) => v.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
    );
  }


  addLine() {
    if (!this.partnumbers.map((pn: string) => pn.toUpperCase()).includes(this.currentPartNumber.toUpperCase())) {
      alert("Piesa introdusă nu există!");
      return;
    }
    if (this.currentQuantity <= 0) {
      alert("Cantitatea introdusă nu este validă!");
      return;
    }
    if (this.currentCountryOfExpedition === '') {
      alert("Țara de expediție introdusă nu este validă!");
      return;
    }
    if (this.lines.has(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase())) {
      if (confirm(`Există deja o linie cu Part Number-ul ${this.currentPartNumber}${(this.currentPart == '' || this.currentPart == null) ? '' : (', piesa ' + this.currentPart)}, Cantitatea ${this.lines.get(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase())} și Țara de Expediție ${this.linesCountries.get(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase())}. Doriți actualizarea datelor liniei?`)) {
        this.lines.set(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase(), this.currentQuantity);
        this.linesCountries.set(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase(), this.currentCountryOfExpedition);
        this.currentPartNumber = '';
        this.currentCountryOfExpedition = '';
        this.currentQuantity = 0;
      }
      return;
    }
    this.lines.set(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase(), this.currentQuantity);
    this.linesCountries.set(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase(), this.currentCountryOfExpedition);
    this.linesDetails.set(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase(), {
      "mac": [],
      "sn": []
    });
    this.currentPartNumber = '';
    this.currentPart = '';
    this.currentCountryOfExpedition = '';
    this.currentQuantity = 0;
  }


  modifyLineDetails(modalLinesDetails: TemplateRef<any>, partNo: string, partName: string) {

    this.currentModifiablePartNo = partNo.toUpperCase();
    this.currentModifiablePartName = partName.toUpperCase();
    this.backupLineDetail.number = JSON.parse(JSON.stringify(this.lines.get(partNo.toUpperCase() + '\t' + partName.toUpperCase())));
    this.backupLineDetail.details = JSON.parse(JSON.stringify(this.linesDetails.get(partNo.toUpperCase() + '\t' + partName.toUpperCase())));
    this.currentModifiableCountryOfExpedition = this.linesCountries.get(partNo.toUpperCase() + '\t' + partName.toUpperCase());
    this.currentOrderPageSN = 1;
    this.numberOfOrderPagesSN = this.backupLineDetail.details.sn.length % 3 == 0 ?
      Math.floor(this.backupLineDetail.details.sn.length / 3) : (Math.floor(this.backupLineDetail.details.sn.length / 3) + 1);
    this.currentOrderPageMAC = 1;
    this.numberOfOrderPagesMAC = this.backupLineDetail.details.mac.length % 3 == 0 ?
      Math.floor(this.backupLineDetail.details.mac.length / 3) : (Math.floor(this.backupLineDetail.details.mac.length / 3) + 1);
    this.currentModifiableQuantity = this.lines.get(partNo.toUpperCase() + '\t' + partName.toUpperCase());
    this.modalService.open(modalLinesDetails, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      keyboard: false
    }).result.then(
      (result) => {
      },
      (reason) => {
      });
  }

  deleteLine(partNo: string, partName: string) {
    if (confirm(`Sunteți sigur(ă) ca doriți să ștergeți linia cu Part Number-ul ${partNo}? (Toate datele asociate vor fi șterse)`)) {
      this.lines.delete(partNo.toUpperCase() + '\t' + partName.toUpperCase());
      this.linesDetails.delete(partNo.toUpperCase() + '\t' + partName.toUpperCase());
      this.linesCountries.delete(partNo.toUpperCase() + '\t' + partName.toUpperCase());
    }
  }

  applyLinesDetailsModifications(modalLinesDetails: any) {
    if (this.currentModifiableQuantity <= 0) {
      alert("Cantitatea introdusă nu este validă");
      return;
    }
    this.lines.set(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase(), this.currentModifiableQuantity);
    this.linesCountries.set(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase(), this.currentModifiableCountryOfExpedition);
    modalLinesDetails.dismiss();
  }

  restoreLinesDetailsModifications(modalLinesDetails: any) {
    //this.lines.set(this.currentModifiablePartNo.toUpperCase(), this.backupLineDetail.number);
    this.linesDetails.set(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase(), this.backupLineDetail.details);
    modalLinesDetails.dismiss();
  }

  deleteSN(snDel: any) {
    this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn =
      this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.filter((sn: any) => {
        return sn.Item1 != snDel;
      });
    this.numberOfOrderPagesSN = this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length % 3 == 0 ?
      Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length / 3) : (Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length / 3) + 1);
    if (this.currentOrderPageSN > this.numberOfOrderPagesSN) {
      this.currentOrderPageSN = 1;
    }
  }

  addSN() {
    if (this.currentSN == "") {
      alert("Câmpul de serial number nu a fost completat!");
      return;
    }
    let addedSN = this.currentSN.split(' ').filter((s: any) => s != '');
    for (let s of addedSN) {
      if (!this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.map((sn: any) => sn.Item1.toUpperCase()).includes(s.toUpperCase())) {
        this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.push({
          Item1: s.toUpperCase(),
          Item2: null,
          Item3: null
        });

        this.numberOfOrderPagesSN = this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length % 3 == 0 ?
          Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length / 3) : (Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length / 3) + 1);
      }
    }
    this.currentSN = '';
  }

  getSNPage() {
    return this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.filter(
      (value: number, index: number) => index >= (this.currentOrderPageSN - 1) * 3 && index <= this.currentOrderPageSN * 3 - 1);
  }


  goToNextPageSN() {
    this.currentOrderPageSN++;
    if (this.currentOrderPageSN > this.numberOfOrderPagesSN) {
      this.currentOrderPageSN = 1;
    }
  }

  goToPrevPageSN() {
    this.currentOrderPageSN--;
    if (this.currentOrderPageSN == 0) {
      this.currentOrderPageSN = this.numberOfOrderPagesSN;
    }
  }

  addMAC() {
    if (this.currentMAC == "") {
      alert("Câmpul de MAC nu a fost completat!");
      return;
    }

    let addedMacs = this.currentMAC.split(' ').filter((m: any) => m != '');


    for (let m of addedMacs) {
      if (!this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.map((mac: any) => mac.Item1.toUpperCase()).includes(m.toUpperCase())) {
        this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.push({
          Item1: m.toUpperCase(),
          Item2: null,
          Item3: null
        });
      }
      this.numberOfOrderPagesMAC = this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length % 3 == 0 ?
        Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length / 3) : (Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length / 3) + 1);
    }


    this.currentMAC = '';
  }

  getMACPage() {
    return this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.filter(
      (value: number, index: number) => index >= (this.currentOrderPageMAC - 1) * 3 && index <= this.currentOrderPageMAC * 3 - 1);
  }

  deleteMAC(macDel: any) {
    this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac =
      this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.filter((mac: any) => {
        return mac.Item1 != macDel;
      });
    this.numberOfOrderPagesMAC = this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length % 3 == 0 ?
      Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length / 3) : (Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length / 3) + 1);
    if (this.currentOrderPageMAC > this.numberOfOrderPagesMAC) {
      this.currentOrderPageMAC = 1;
    }
  }

  goToPrevPageMAC() {
    this.currentOrderPageMAC--;
    if (this.currentOrderPageMAC == 0) {
      this.currentOrderPageMAC = this.numberOfOrderPagesMAC;
    }
  }

  goToNextPageMAC() {
    this.currentOrderPageMAC++;
    if (this.currentOrderPageMAC > this.numberOfOrderPagesMAC) {
      this.currentOrderPageMAC = 1;
    }
  }

  getOrderLineCodes() {
    let returnValue = [];
    for (let i of this.lines) {
      let orderLineCodes = {
        PartNo: i[0].split('\t')[0],
        Cantitate: i[1],
        TaraExpediere: this.linesCountries.get(i[0]),
        PartName: i[0].split('\t')[1],
        SN: this.linesDetails.get(i[0]).sn,
        MAC: this.linesDetails.get(i[0]).mac
      }
      returnValue.push(orderLineCodes);
    }
    return returnValue;
  }

  refreshParts() {
    this.http.get<any>(`${APIHelper.APIUrl}part?partNo=${encodeURIComponent(this.currentPartNumber)}`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.parts = response.map((r: any) => r.Nume);
      }, (error: any) => {
      });
  }
}
